<script lang="ts">
  import { Icons, type IconType } from '../icon';
  import { twMerge } from 'tailwind-merge';

  export let icon: IconType;
  export let disabled = false;
  let classname = '';
  export { classname as class };
  export let iconClass = '';
  export let iconNumberOfPaths: number = 0;
  export let displayBorder: boolean = false;
  export let onClick = () => {};
  export let title = '';

  $: {
    if (disabled) {
      classname += ' disabled:text-secondary-500 ';
    } else {
      if (displayBorder) {
        classname += `active:text-tertiary-500 active:bg-transparent active:border-[--buttonBorder] border-[--buttonBorder hover:!bg-surface-500`;
      } else {
        classname += ` hover:border-[--buttonBorder] hover:border-[1px] hover:bg-white
          active:text-tertiary-500 active:bg-transparent active:border-transparent `;
      }
    }
  }

  let iconClasses: string;
  $: {
    if (displayBorder) {
      iconClasses = 'bg-transparent text-[20px] text-xl !leading-none hover:!bg-surface-500 active:bg-transparent ';
    } else {
      iconClasses = 'bg-transparent text-[20px] text-xl !leading-none hover:bg-white active:bg-transparent ';
    }
  }
</script>

<button
  type="button"
  title={title}
  class={twMerge(` flex h-[40px] w-[40px] items-center justify-center rounded-lg border-[1px] border-transparent bg-transparent `, classname)}
  {disabled}
  on:click={onClick}
>
  <svelte:component this={Icons[icon]} class={twMerge(iconClasses, iconClass)} numberofPaths={iconNumberOfPaths} />
</button>
